var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-keep-alive",
    {
      staticClass: "base-virtual-scroll-viewport",
      style: _vm.virtualViewportStyle,
    },
    [
      _vm.isHeaderVisible
        ? _c(
            "base-resize-observer",
            {
              key: _vm.HEADER_SLOT_KEY,
              on: {
                resize: function ($event) {
                  return _vm.$emit("header-slot-resize", $event)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "base-virtual-scroll-viewport-item" },
                [_vm._t("header")],
                2
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.visibleItems, function (item, vIndex) {
        return _c("base-virtual-scroll-viewport-item", {
          key: _vm.getItemId(item),
          attrs: {
            item: item,
            "item-id": _vm.getItemId(item),
            "item-size": _vm.getItemSize(item),
            "real-index": _vm.getRealIndex(vIndex),
            "active-item-id": _vm.activeItemId,
            "is-scrolling": _vm.isScrolling,
          },
          on: {
            activation: function ($event) {
              return _vm.handleItemActivation(item)
            },
            deactivation: function ($event) {
              return _vm.handleItemDeactivation(item)
            },
            resize: function ($event) {
              return _vm.handleItemResize(item, $event)
            },
          },
          scopedSlots: _vm._u(
            [
              {
                key: "default",
                fn: function () {
                  return [
                    _vm._t("default", null, {
                      index: _vm.getRealIndex(vIndex),
                      data: item,
                      context: _vm.context,
                      activeItemId: _vm.activeItemId,
                    }),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        })
      }),
      _vm._v(" "),
      _vm.isFooterVisible
        ? _c(
            "base-resize-observer",
            {
              key: _vm.FOOTER_SLOT_KEY,
              on: {
                resize: function ($event) {
                  return _vm.$emit("footer-slot-resize", $event)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "base-virtual-scroll-viewport-item" },
                [_vm._t("footer")],
                2
              ),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }